export default "__VITE_ASSET__DI3aI93a__"